import { createShigoApiClient, type ShigoApiConfig } from '../../lib/shigo-api-client';
import {
  dashboardLastImportSchema,
  dashboardMetricValueField,
  dashboardOverviewSchema,
  type DashboardMetric,
  type DashboardOverviewFilter,
  DashboardScope,
} from './model';

interface DashboardClientOptions {
  config: ShigoApiConfig;
  accessToken: string;
  fetcher?: typeof fetch;
}

export function createDashboardClient({ config, accessToken, fetcher }: DashboardClientOptions) {
  const api = createShigoApiClient(config, accessToken, fetcher);
  return {
    overview(
      filter: DashboardOverviewFilter,
      signal?: AbortSignal,
      scope: DashboardScope = DashboardScope.Main,
    ) {
      const path =
        scope === DashboardScope.SuperAdmin ? '/api/sa-dash/report' : '/api/dashboard/report';
      if (filter.preset) {
        const search = new URLSearchParams({
          presetDateRange: filter.preset,
          offsetCount: '0',
        });
        return api.request({
          path: `${path}/overview-presets?${search.toString()}`,
          schema: dashboardOverviewSchema,
          ...(signal ? { init: { signal } } : {}),
        });
      }
      const search = new URLSearchParams({
        dateFrom: filter.dateFrom,
        dateTo: filter.dateTo,
      });
      return api.request({
        path: `${path}?${search.toString()}`,
        schema: dashboardOverviewSchema,
        ...(signal ? { init: { signal } } : {}),
      });
    },
    lastImport(signal?: AbortSignal) {
      return api.request({
        path: '/api/report/ch/last-import-time',
        schema: dashboardLastImportSchema,
        ...(signal ? { init: { signal } } : {}),
      });
    },
  };
}

export function dashboardMetricApiField(metric: DashboardMetric) {
  return dashboardMetricValueField[metric];
}
